import type { UrlObject } from 'url';

/** The type accepted by NextJS on links and in the router */
export type OpaqueUrl = string | UrlObject;

export const buildPath = (...parts: string[]) => `/${parts.map(encodeURIComponent).join('/')}`;

export const removeParamFromUrl = (url: URL, paramKey: string) => {
  url.searchParams.delete(paramKey);
  const paramString = url.searchParams.toString();
  const queryString = paramString.length ? `?${paramString}` : ``;
  return `${url.origin}${url.pathname}${queryString}${url.hash}`;
};

export const hasTrailingSlash = (stringUrl: string) => TRAILING_SLASH.test(stringUrl);

const TRAILING_SLASH = /\/($|#|\?)/;
